import dayjs from "dayjs";
import { UserCircleIcon } from "icons";
import React from "react";
import { Avatar, Text } from "ui-components";

import { useChat } from "@/src/hooks/useChat";
import { useChatFunctions } from "@/src/hooks/useChatFunctions";

export function NewConversationCard(): JSX.Element | null {
  const { chatMetaData, selectedConversation, conversations } = useChat();
  const { getOtherConversationUser } = useChatFunctions();

  let isExistInConversation: undefined | boolean;
  conversations?.data.forEach((conversation) => {
    const firstRecipient = getOtherConversationUser(
      conversation.conversationRecipients
    );
    if (firstRecipient && firstRecipient?.id === selectedConversation?.userId) {
      isExistInConversation = true;
    }
  });

  if (chatMetaData.isSearchConnectionOpen) {
    return (
      <div className="flex flex-row  gap-2 m-2">
        <UserCircleIcon className="w-12 h-12" />
        <div className="flex flex-col flex-1 p-1">
          <div className="flex justify-between">
            <Text variant="base-thin">New Message</Text>
            <Text variant="base-thin">{dayjs().format("D MMM YY")}</Text>
          </div>
        </div>
      </div>
    );
  }

  if (selectedConversation && !isExistInConversation) {
    return (
      <div className="p-2 bg-brand-primary-10">
        <div className="flex flex-row flex-1 w-full gap-2">
          <Avatar
            alt="user profile"
            src={selectedConversation?.logoSrc}
            size="xs"
          />
          <div className="flex flex-col flex-1 p-1">
            <div className="flex justify-between">
              <Text>{selectedConversation?.title}</Text>
              <Text>{dayjs().format("D MMM YY")}</Text>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return null;
}
